import LoadingTextSkeleton from '@components/skeleton/LoadingTextSkeleton';
import { Divider, Stack, Typography } from '@mui/material';
import { useCameraDetailContext } from '@pages/cameras/hook/CameraDetailsProvider';
import color from '@theme/Colors';
import { ReactNode, useEffect } from 'react';
import { transformScheduleData } from 'src/helpers';
import {
    BaseSectionCollapse,
    DataSectionHasSubItem,
    SectionHasSubItemHeader,
    SectionHasSubItemProps,
} from '../../../ptz/milesight/components/BasicInfoMilesightCameraPTZ';
import useMileSightSP111, { SectionsCollapseSP111 } from '@pages/cameras/hook/useMilesightSP111';

type Props = {
    isOpenCollapse: { [key in SectionsCollapseSP111]: boolean };
    handleToggleCollapse: (section: SectionsCollapseSP111) => void;
};

export default function InitialPositionMilesightsCameraSP111(props: Props) {
    const handleEdit = () => {
        console.log('Edit button clicked');
    };

    const { camera, filteredCamera } = useCameraDetailContext();
    const { isOpenCollapse, handleToggleCollapse } = props;
    const { SP111ScheduledTask, isLoadingSP111ScheduledTask } = useMileSightSP111({
        filteredCamera,
        cameraSP111: camera.SP111CameraId!,
    });

    const dataSectionHasSubItems: DataSectionHasSubItem[] = transformScheduleData(
        SP111ScheduledTask?.ScheduleList!,
        (dayName, schedule) => ({
            label: `${dayName}: `,
            value: schedule,
        })
    );

    const sectionHasSubItemProps: SectionHasSubItemProps = {
        title: 'Schedule settings',
        data: dataSectionHasSubItems,
    };

    const sectionsInitialPosition: SectionHasSubItemProps[] = [
        {
            title: sectionHasSubItemProps.title,
            data: sectionHasSubItemProps.data,
        },
        {
            title: 'Tasks interference settings',
            data: [
                {
                    label: 'Latency time:',
                    value: (
                        <LoadingTextSkeleton
                            conditions={isLoadingSP111ScheduledTask}
                            value={`${SP111ScheduledTask?.RecoveryTime!}s (5-720s)`}
                            loadingStyle={{
                                width: '50%',
                            }}
                        />
                    ),
                },
            ],
        },
    ];

    return (
        <Stack id="initialPosition" border={'1px solid #E4E7EC'} borderRadius={2} flex={1}>
            {/* Basic Information */}
            <SectionHasSubItemHeader id="" title="Initial position" onEdit={handleEdit} />

            {/* Scheduled tasks */}
            <BaseSectionCollapse
                id="scheduledTasks"
                title="Scheduled tasks"
                isOpen={isOpenCollapse.scheduledTasks}
                onToggle={() => {
                    handleToggleCollapse(SectionsCollapseSP111.ScheduledTasks);
                }}
                sections={sectionsInitialPosition}
            />
        </Stack>
    );
}
